import { IconPropsType } from '..';

export const ArrowUpIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.58089 12.6864C5.40613 12.6864 5.26534 12.6281 5.15854 12.5116C5.05174 12.3951 4.99834 12.2592 4.99834 12.1038C4.99834 12.065 5.05659 11.929 5.1731 11.696L9.39665 7.47248C9.49374 7.37539 9.59084 7.30742 9.68793 7.26858C9.78502 7.22975 9.89183 7.21033 10.0083 7.21033C10.1248 7.21033 10.2317 7.22975 10.3287 7.26858C10.4258 7.30742 10.5229 7.37539 10.62 7.47248L14.8436 11.696C14.9018 11.7543 14.9455 11.8174 14.9746 11.8854C15.0038 11.9533 15.0183 12.0261 15.0183 12.1038C15.0183 12.2592 14.9649 12.3951 14.8581 12.5116C14.7513 12.6281 14.6105 12.6864 14.4358 12.6864H5.58089Z"
      fill="currentColor"
    />
  </svg>
);
